import KeywordSpottingConfigRepo from '@infinity/ca-tester/repos/keywordSpottingConfig'

export default class KeywordTransferRepo extends KeywordSpottingConfigRepo {
  constructor (installationId: string) {
    super()

    super.apiRoute = `installation/${installationId}/keywordConfig`
  }
}
